import { Breadcrumbs } from '@cloudflare/kumo'
import { HouseIcon } from '@phosphor-icons/react'
import type { BuildingHours } from '@hub-wifi/shared'
import { useTranslation } from '../../i18n'
import { todayYmdInTz } from '../../lib/calendar-time'
import { formatWeekdayDate } from '../../lib/format'
import { PageHeader } from '../kumo/page-header/page-header'
import { dayPeriod, openStatus } from './building-status'

export interface HomeGreetingProps {
  firstName: string
  hours: BuildingHours[]
  timeZone: string
  now: Date
}

/** "Good afternoon, Ana" + "Thu, 29 Oct · Open now until 18:00". */
export function HomeGreeting({ firstName, hours, timeZone, now }: HomeGreetingProps) {
  const { t, locale } = useTranslation()
  const period = dayPeriod(timeZone, now)
  const title = firstName
    ? t(`dashboard.greeting.${period}`, { name: firstName })
    : t(`dashboard.greeting.${period}NoName`)

  const status = openStatus(hours, timeZone, now)
  const statusText =
    status?.state === 'open'
      ? t('dashboard.status.openUntil', { time: status.until })
      : status?.state === 'opensAt'
        ? t('dashboard.status.opensAt', { time: status.at })
        : status?.state === 'closed'
          ? t('dashboard.status.closed')
          : null
  const dateText = formatWeekdayDate(todayYmdInTz(timeZone, now), locale ?? 'pt-BR')
  const description = statusText ? `${dateText} · ${statusText}` : dateText

  return (
    <PageHeader
      breadcrumbs={
        <Breadcrumbs>
          <Breadcrumbs.Current icon={<HouseIcon size={14} />}>{t('nav.home')}</Breadcrumbs.Current>
        </Breadcrumbs>
      }
      title={title}
      description={description}
    />
  )
}
